//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['text'],
    data: function data() {
        return {
            dialog: false
        };
    },

    methods: {
        showLoader: function showLoader() {
            this.dialog = true;
        },
        closeLoader: function closeLoader() {
            this.dialog = false;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/loader.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/loader.vue
// module chunks = 34